// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/oms/oms.proto (package aurora.core.apiengine.omsv1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Currency, PbAgreementInfo, PbInstrument, PbInstrumentInfo, RateLimit } from "../../../../common/protos/types_pb";
import { file_common_protos_types } from "../../../../common/protos/types_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { InstrumentIdType, OmsOrderStatus, OmsOrderType, OmsTimeInForceType, OrderIntent } from "../../../../consts/omsconsts_pb";
import { file_consts_omsconsts } from "../../../../consts/omsconsts_pb";
import type { Side } from "../../../../consts/commonconsts_pb";
import { file_consts_commonconsts } from "../../../../consts/commonconsts_pb";
import type { SettlementType } from "../../../../consts/settlementconsts_pb";
import { file_consts_settlementconsts } from "../../../../consts/settlementconsts_pb";
import type { CollateralType, DeliveryType } from "../../../../consts/agreementconsts_pb";
import { file_consts_agreementconsts } from "../../../../consts/agreementconsts_pb";
import type { BigintFilter, DateFilter, DecimalFilter, OrderIntentFilter, OrderStatusSetFilter, OrderTypeFilter, SideFilter, SortableField, SortOrder, StringFilter, StringSetFilter, TimeInForceFilter } from "../../../../consts/queryconsts_pb";
import { file_consts_queryconsts } from "../../../../consts/queryconsts_pb";
import type { Execution } from "../executions/executions_pb";
import { file_modules_apiengine_services_executions_executions } from "../executions/executions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/oms/oms.proto.
 */
export const file_modules_apiengine_services_oms_oms: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_common_protos_types, file_google_protobuf_empty, file_consts_omsconsts, file_consts_commonconsts, file_consts_settlementconsts, file_consts_agreementconsts, file_consts_queryconsts, file_modules_apiengine_services_executions_executions]);

/**
 * @generated from message aurora.core.apiengine.omsv1.CreateOrderRequest
 */
export type CreateOrderRequest = Message<"aurora.core.apiengine.omsv1.CreateOrderRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order with any internal record keeping.
   * When provided needs to be a unique value within the past 12 hours,
   *  if the same value is observed then the request will be rejected.
   *
   * @generated from field: optional string version_reference = 1;
   */
  versionReference?: string;

  /**
   * The ticker symbol or CUSIP of the security you intend to lend or borrow
   *
   * @generated from field: string instrument_id = 2;
   */
  instrumentId: string;

  /**
   * Describes the instrument_id provided. (CUSIP, Ticker)
   *
   * @generated from field: aurora.core.consts.oms.InstrumentIdType instrument_id_type = 3;
   */
  instrumentIdType: InstrumentIdType;

  /**
   * The side you are intending to take on the trade
   *
   * @generated from field: aurora.core.consts.common.Side side = 4;
   */
  side: Side;

  /**
   * The order type
   * - LIMIT is a matchable order
   * - IOI (Indication of Interest) is a display only order and will never be matched
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderType order_type = 5;
   */
  orderType: OmsOrderType;

  /**
   * The number of shares you intend to borrow or lend
   *
   * @generated from field: int64 quantity = 6;
   */
  quantity: bigint;

  /**
   * The minimum quantity that the order can be matched against. If not specified the default will be 100.
   *
   * @generated from field: optional int64 min_quantity = 7;
   */
  minQuantity?: bigint;

  /**
   * Specifies how long the order remains active.
   *
   * @generated from field: aurora.core.consts.oms.OmsTimeInForceType time_in_force = 8;
   */
  timeInForce: OmsTimeInForceType;

  /**
   * If time in force is “GOOD_TILL_TIME”, the date/time the order is to be canceled is required. Time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string good_till_time = 15;
   */
  goodTillTime?: string;

  /**
   * Rate Limit - either as Fee or as Rebate (specified through RateLimit.type)
   * Optional for following order types: IOI
   * And not applicable for following order types: Market
   *
   * @generated from field: optional aurora.core.common.protos.RateLimit rate_limit = 9;
   */
  rateLimit?: RateLimit;

  /**
   * Optional filter to automatically select all agreements that match the specified criteria.
   *
   * @generated from field: optional aurora.core.apiengine.omsv1.AgreementsFilter agreements_filter = 12;
   */
  agreementsFilter?: AgreementsFilter;

  /**
   * All orders will be marked as “Active” by default or Inactive order.
   *
   * @generated from field: optional bool active = 13;
   */
  active?: boolean;

  /**
   * - IOI (Indication of Interest) is a display only order and will never be matched
   *
   * @generated from field: aurora.core.consts.oms.OrderIntent order_intent = 14;
   */
  orderIntent: OrderIntent;

  /**
   * Customer internal id that will be reflected on the order and can be used to query the order
   *
   * @generated from field: optional string external_id = 16;
   */
  externalId?: string;

  /**
   * All orders will allow odd lots by default
   *
   * @generated from field: optional bool allow_odd_lots = 17;
   */
  allowOddLots?: boolean;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CreateOrderRequest.
 * Use `create(CreateOrderRequestSchema)` to create a new message.
 */
export const CreateOrderRequestSchema: GenMessage<CreateOrderRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 0);

/**
 * @generated from message aurora.core.apiengine.omsv1.AgreementsFilter
 */
export type AgreementsFilter = Message<"aurora.core.apiengine.omsv1.AgreementsFilter"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * @generated from field: repeated string counterparty_ids = 2;
   */
  counterpartyIds: string[];

  /**
   * @generated from field: repeated aurora.core.consts.agreements.CollateralType collateral_types = 3;
   */
  collateralTypes: CollateralType[];

  /**
   * @generated from field: repeated aurora.core.consts.settlement.SettlementType settlement_types = 4;
   */
  settlementTypes: SettlementType[];

  /**
   * @generated from field: repeated string booking_accounts = 5;
   */
  bookingAccounts: string[];

  /**
   * @generated from field: repeated string counterparty_booking_accounts = 6;
   */
  counterpartyBookingAccounts: string[];

  /**
   * @generated from field: repeated string trade_types = 7;
   */
  tradeTypes: string[];

  /**
   * @generated from field: repeated aurora.core.common.protos.Currency collateral_currencies = 8;
   */
  collateralCurrencies: Currency[];

  /**
   * @generated from field: repeated aurora.core.consts.agreements.DeliveryType delivery_types = 9;
   */
  deliveryTypes: DeliveryType[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.AgreementsFilter.
 * Use `create(AgreementsFilterSchema)` to create a new message.
 */
export const AgreementsFilterSchema: GenMessage<AgreementsFilter> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 1);

/**
 * @generated from message aurora.core.apiengine.omsv1.CreateOrderResponse
 */
export type CreateOrderResponse = Message<"aurora.core.apiengine.omsv1.CreateOrderResponse"> & {
  /**
   * Unique identifier assigned to this order by Provable Markets
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CreateOrderResponse.
 * Use `create(CreateOrderResponseSchema)` to create a new message.
 */
export const CreateOrderResponseSchema: GenMessage<CreateOrderResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 2);

/**
 * @generated from message aurora.core.apiengine.omsv1.ModifyOrderRequest
 */
export type ModifyOrderRequest = Message<"aurora.core.apiengine.omsv1.ModifyOrderRequest"> & {
  /**
   * The Provable Markets assigned order identifier for the order to be modified
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Used for version control, the user can provide the last known version_reference to ensure any modifications are applied to the intended version.
   *
   * @generated from field: optional string current_version_reference = 2;
   */
  currentVersionReference?: string;

  /**
   * A new identifier to be assigned to the order.
   * When provided needs to be a unique value within the past 12 hours,
   *  if the same value is observed then the request will be rejected.
   *
   * @generated from field: optional string new_version_reference = 3;
   */
  newVersionReference?: string;

  /**
   * The updated quantity you want on the order.
   * Note: This will replace the current quantity and is not a delta.
   *
   * @generated from field: optional int64 quantity = 4;
   */
  quantity?: bigint;

  /**
   * The updated minimum quantity that you want set on the order.
   *
   * @generated from field: optional int64 min_quantity = 5;
   */
  minQuantity?: bigint;

  /**
   * Rate Limit - either as Fee or as Rebate (specified through RateLimit.Type)
   * Optional for following order types: IOI
   * And not applicable for following order types: Market
   *
   * @generated from field: optional aurora.core.common.protos.RateLimit rate_limit = 6;
   */
  rateLimit?: RateLimit;

  /**
   * Optional filter to automatically select all agreements that match the specified criteria.
   *
   * @generated from field: optional aurora.core.apiengine.omsv1.AgreementsFilter agreements_filter = 7;
   */
  agreementsFilter?: AgreementsFilter;

  /**
   * If true the order goes to matching venue
   *
   * @generated from field: optional bool active = 8;
   */
  active?: boolean;

  /**
   * Time In Force type (e.g. day, gtc, fok, ioc, gtt)
   *
   * @generated from field: optional aurora.core.consts.oms.OmsTimeInForceType time_in_force = 9;
   */
  timeInForce?: OmsTimeInForceType;

  /**
   * Specific expiry time - only used (and required) with tif=GTT - time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string good_till_time = 10;
   */
  goodTillTime?: string;

  /**
   * Customer internal id that will be reflected on the order and can be used to query the order
   *
   * @generated from field: optional string external_id = 16;
   */
  externalId?: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.ModifyOrderRequest.
 * Use `create(ModifyOrderRequestSchema)` to create a new message.
 */
export const ModifyOrderRequestSchema: GenMessage<ModifyOrderRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 3);

/**
 * @generated from message aurora.core.apiengine.omsv1.ModifyOrderResponse
 */
export type ModifyOrderResponse = Message<"aurora.core.apiengine.omsv1.ModifyOrderResponse"> & {
  /**
   * Provable Markets assigned order identifier for the order modified
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.ModifyOrderResponse.
 * Use `create(ModifyOrderResponseSchema)` to create a new message.
 */
export const ModifyOrderResponseSchema: GenMessage<ModifyOrderResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 4);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelOrderRequest
 */
export type CancelOrderRequest = Message<"aurora.core.apiengine.omsv1.CancelOrderRequest"> & {
  /**
   * Unique identifier of the order to be cancelled
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelOrderRequest.
 * Use `create(CancelOrderRequestSchema)` to create a new message.
 */
export const CancelOrderRequestSchema: GenMessage<CancelOrderRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 5);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelOrderResponse
 */
export type CancelOrderResponse = Message<"aurora.core.apiengine.omsv1.CancelOrderResponse"> & {
  /**
   * Provable Markets assigned order identifier for the order canceled
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelOrderResponse.
 * Use `create(CancelOrderResponseSchema)` to create a new message.
 */
export const CancelOrderResponseSchema: GenMessage<CancelOrderResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 6);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelOrdersRequest
 */
export type CancelOrdersRequest = Message<"aurora.core.apiengine.omsv1.CancelOrdersRequest"> & {
  /**
   * List of order ids to be canceled
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelOrdersRequest.
 * Use `create(CancelOrdersRequestSchema)` to create a new message.
 */
export const CancelOrdersRequestSchema: GenMessage<CancelOrdersRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 7);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelOrdersResponse
 */
export type CancelOrdersResponse = Message<"aurora.core.apiengine.omsv1.CancelOrdersResponse"> & {
  /**
   * list of order ids for which the cancellation request has been successfully received.
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * list of errors occurred while attempting to cancel the order.
   *
   * @generated from field: repeated aurora.core.apiengine.omsv1.CancelOrderError errors = 2;
   */
  errors: CancelOrderError[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelOrdersResponse.
 * Use `create(CancelOrdersResponseSchema)` to create a new message.
 */
export const CancelOrdersResponseSchema: GenMessage<CancelOrdersResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 8);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelOrderError
 */
export type CancelOrderError = Message<"aurora.core.apiengine.omsv1.CancelOrderError"> & {
  /**
   * Unique identifier of the order to be canceled - optional
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Error when attempting to cancel the order
   *
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelOrderError.
 * Use `create(CancelOrderErrorSchema)` to create a new message.
 */
export const CancelOrderErrorSchema: GenMessage<CancelOrderError> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 9);

/**
 * @generated from message aurora.core.apiengine.omsv1.Order
 */
export type Order = Message<"aurora.core.apiengine.omsv1.Order"> & {
  /**
   * Provable Markets assigned order identifier for the order event notification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Customer internal id of the order
   *
   * @generated from field: optional string external_id = 26;
   */
  externalId?: string;

  /**
   * An identifier provided by the user to help associate with any internal references.
   *
   * @generated from field: string version_reference = 2;
   */
  versionReference: string;

  /**
   * Cusip or Ticker of instrument
   *
   * @generated from field: aurora.core.common.protos.PbInstrument instrument = 3;
   */
  instrument?: PbInstrument;

  /**
   * Side of order (lender or borrower)
   *
   * @generated from field: aurora.core.consts.common.Side side = 4;
   */
  side: Side;

  /**
   * The current status of the order.
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderStatus order_status = 5;
   */
  orderStatus: OmsOrderStatus;

  /**
   * The order type
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderType order_type = 6;
   */
  orderType: OmsOrderType;

  /**
   * The order intent (IOI, FIRM)
   *
   * @generated from field: aurora.core.consts.oms.OrderIntent order_intent = 7;
   */
  orderIntent: OrderIntent;

  /**
   * Time In Force type (e.g. day, gtc, fok, ioc)
   *
   * @generated from field: aurora.core.consts.oms.OmsTimeInForceType time_in_force = 8;
   */
  timeInForce: OmsTimeInForceType;

  /**
   * The time the order will be canceled if populated. Time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string good_till_time = 9;
   */
  goodTillTime?: string;

  /**
   * The number of shares on the original order
   *
   * @generated from field: int64 quantity = 10;
   */
  quantity: bigint;

  /**
   * The minimum quantity on the order.
   *
   * @generated from field: int64 min_quantity = 11;
   */
  minQuantity: bigint;

  /**
   * Rate limit, expressed as fee
   * Optional for certain order types: IOI
   * And not applicable for certain order types: Market
   *
   * @generated from field: optional string fee = 12;
   */
  fee?: string;

  /**
   * Rate limit, expressed as rebate (same as fee, but relative to benchmark)
   * Optional for certain order types: IOI
   * And not applicable for certain order types: Market
   *
   * @generated from field: optional string rebate = 13;
   */
  rebate?: string;

  /**
   * agreements set on the order
   *
   * @generated from field: repeated string agreement_ids = 14;
   */
  agreementIds: string[];

  /**
   * The number of shares still open on the order
   *
   * @generated from field: int64 open_quantity = 15;
   */
  openQuantity: bigint;

  /**
   * Total shares executed on order so far
   *
   * @generated from field: int64 total_execution_quantity = 16;
   */
  totalExecutionQuantity: bigint;

  /**
   * Average fee of executed quantity so far
   *
   * @generated from field: optional string avg_execution_fee = 17;
   */
  avgExecutionFee?: string;

  /**
   * Average rebate of executed quantity so far
   *
   * @generated from field: optional string avg_execution_rebate = 18;
   */
  avgExecutionRebate?: string;

  /**
   * Order created at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 19;
   */
  createdAt: string;

  /**
   * Order was last changed at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string updated_at = 20;
   */
  updatedAt: string;

  /**
   * Created by user
   *
   * @generated from field: string created_by = 21;
   */
  createdBy: string;

  /**
   * Last updated by user
   *
   * @generated from field: string last_updated_by = 22;
   */
  lastUpdatedBy: string;

  /**
   * The number of shares exposed as Firm order
   *
   * @generated from field: int64 firm_quantity = 23;
   */
  firmQuantity: bigint;

  /**
   * The number of shares exposed as IOI order
   *
   * @generated from field: int64 ioi_quantity = 24;
   */
  ioiQuantity: bigint;

  /**
   * List of executions on this Order
   *
   * @generated from field: repeated aurora.core.apiengine.executionsv1.Execution executions = 25;
   */
  executions: Execution[];

  /**
   * Allow odd lots
   *
   * @generated from field: bool allow_odd_lots = 27;
   */
  allowOddLots: boolean;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema: GenMessage<Order> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 10);

/**
 * @generated from message aurora.core.apiengine.omsv1.GetOrderRequest
 */
export type GetOrderRequest = Message<"aurora.core.apiengine.omsv1.GetOrderRequest"> & {
  /**
   * Unique identifier of the order
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.GetOrderRequest.
 * Use `create(GetOrderRequestSchema)` to create a new message.
 */
export const GetOrderRequestSchema: GenMessage<GetOrderRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 11);

/**
 * @generated from message aurora.core.apiengine.omsv1.GetOrderResponse
 */
export type GetOrderResponse = Message<"aurora.core.apiengine.omsv1.GetOrderResponse"> & {
  /**
   * Details of the order returned by Aurora
   *
   * @generated from field: aurora.core.apiengine.omsv1.Order order = 1;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.GetOrderResponse.
 * Use `create(GetOrderResponseSchema)` to create a new message.
 */
export const GetOrderResponseSchema: GenMessage<GetOrderResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 12);

/**
 * @generated from message aurora.core.apiengine.omsv1.ListOrdersRequest
 */
export type ListOrdersRequest = Message<"aurora.core.apiengine.omsv1.ListOrdersRequest"> & {
  /**
   * @generated from field: optional string instrument_id = 1;
   */
  instrumentId?: string;

  /**
   * @generated from field: optional aurora.core.consts.oms.InstrumentIdType instrument_id_type = 2;
   */
  instrumentIdType?: InstrumentIdType;

  /**
   * Side of order (lender or borrower) - optional
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 3;
   */
  side?: Side;

  /**
   * DateTime for query to start looking for orders - time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string since = 5;
   */
  since?: string;

  /**
   * Status of the order in Aurora - optional
   *
   * @generated from field: optional aurora.core.consts.oms.OmsOrderStatus order_status = 6;
   */
  orderStatus?: OmsOrderStatus;

  /**
   * list of ids to filter orders by
   *
   * @generated from field: repeated string ids = 7;
   */
  ids: string[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.ListOrdersRequest.
 * Use `create(ListOrdersRequestSchema)` to create a new message.
 */
export const ListOrdersRequestSchema: GenMessage<ListOrdersRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 13);

/**
 * @generated from message aurora.core.apiengine.omsv1.ListOrdersResponse
 */
export type ListOrdersResponse = Message<"aurora.core.apiengine.omsv1.ListOrdersResponse"> & {
  /**
   * Detail(s) of one or more orders returned by Aurora
   *
   * @generated from field: repeated aurora.core.apiengine.omsv1.Order orders = 1;
   */
  orders: Order[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.ListOrdersResponse.
 * Use `create(ListOrdersResponseSchema)` to create a new message.
 */
export const ListOrdersResponseSchema: GenMessage<ListOrdersResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 14);

/**
 * New Unique identifier assigned by the user
 *  string request_id = 1;
 *
 * @generated from message aurora.core.apiengine.omsv1.QueryOrdersRequest
 */
export type QueryOrdersRequest = Message<"aurora.core.apiengine.omsv1.QueryOrdersRequest"> & {
  /**
   * List of filters
   *
   * @generated from field: optional aurora.core.apiengine.omsv1.QueryOrdersFilter filter = 2;
   */
  filter?: QueryOrdersFilter;

  /**
   * List of sorting options
   *
   * @generated from field: repeated aurora.core.apiengine.omsv1.QueryOrdersSort sorts = 3;
   */
  sorts: QueryOrdersSort[];

  /**
   * Page number, 1 being the starting one
   *
   * @generated from field: optional int32 page_number = 4;
   */
  pageNumber?: number;

  /**
   * Number of orders per page
   *
   * @generated from field: optional int32 page_limit = 5;
   */
  pageLimit?: number;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.QueryOrdersRequest.
 * Use `create(QueryOrdersRequestSchema)` to create a new message.
 */
export const QueryOrdersRequestSchema: GenMessage<QueryOrdersRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 15);

/**
 * @generated from message aurora.core.apiengine.omsv1.QueryOrdersFilter
 */
export type QueryOrdersFilter = Message<"aurora.core.apiengine.omsv1.QueryOrdersFilter"> & {
  /**
   * AgGrid provides the offset from UTC for the current browser session
   * This must be used to shift the DateFilters to UTC and is therefore mandatory
   *
   * @generated from field: int32 offset_in_minutes_from_utc = 28;
   */
  offsetInMinutesFromUtc: number;

  /**
   * Include expired orders?
   *
   * @generated from field: optional bool show_all = 1;
   */
  showAll?: boolean;

  /**
   * Unique identifier of the order to get - optional
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter order_ref = 2;
   */
  orderRef?: StringFilter;

  /**
   * Last known Unique order identifier used to create or modify the order assigned by Aurora user - optional
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter version_reference = 3;
   */
  versionReference?: StringFilter;

  /**
   * Ticker of instrument - optional
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter ticker = 4;
   */
  ticker?: StringFilter;

  /**
   * Cusip of instrument - optional
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter cusip = 5;
   */
  cusip?: StringFilter;

  /**
   * ISIN of instrument - optional
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter isin = 48;
   */
  isin?: StringFilter;

  /**
   * Name of the instrument
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter security_name = 27;
   */
  securityName?: StringFilter;

  /**
   * Type of Security (Common Stock, Preferred Stock, ...)
   *
   * @generated from field: optional aurora.core.consts.query.StringSetFilter security_types = 29;
   */
  securityTypes?: StringSetFilter;

  /**
   * Category of Security (Equity, Fixed Income)
   *
   * @generated from field: optional aurora.core.consts.query.StringSetFilter security_categories = 47;
   */
  securityCategories?: StringSetFilter;

  /**
   * Side of the order (LOAN or BORROW) - optional
   *
   * @generated from field: optional aurora.core.consts.query.SideFilter side = 6;
   */
  side?: SideFilter;

  /**
   * Status of the order in Aurora - optional
   *
   * @generated from field: optional aurora.core.consts.query.OrderStatusSetFilter order_status = 7;
   */
  orderStatus?: OrderStatusSetFilter;

  /**
   * Only return orders that are (partial) executed - optional
   *
   * @generated from field: optional bool has_executed = 8;
   */
  hasExecuted?: boolean;

  /**
   * Type of the order (Limit, Market, etc) - optional
   *
   * @generated from field: optional aurora.core.consts.query.OrderTypeFilter order_type = 9;
   */
  orderType?: OrderTypeFilter;

  /**
   * Intent of the order (orders with intent IOI will not be matched).
   *
   * @generated from field: optional aurora.core.consts.query.OrderIntentFilter order_intent = 43;
   */
  orderIntent?: OrderIntentFilter;

  /**
   * Owner of the order - optional for admins
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter company_id = 10;
   */
  companyId?: StringFilter;

  /**
   * Part of an agreement
   *
   * @generated from field: optional aurora.core.consts.query.StringSetFilter agreement_ids = 11;
   */
  agreementIds?: StringSetFilter;

  /**
   * Open quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter open_quantity = 12;
   */
  openQuantity?: BigintFilter;

  /**
   * Executed quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter exec_quantity = 13;
   */
  execQuantity?: BigintFilter;

  /**
   * Total quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter total_quantity = 14;
   */
  totalQuantity?: BigintFilter;

  /**
   * Minimum quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter min_quantity = 15;
   */
  minQuantity?: BigintFilter;

  /**
   * Rate as fee
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter fee = 16;
   */
  fee?: DecimalFilter;

  /**
   * Rate as rebate
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter rebate = 17;
   */
  rebate?: DecimalFilter;

  /**
   * Average rate of executed order as fee
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter avg_execution_fee = 18;
   */
  avgExecutionFee?: DecimalFilter;

  /**
   * Average rate of executed order as rebate
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter avg_execution_rebate = 19;
   */
  avgExecutionRebate?: DecimalFilter;

  /**
   * Timestamp when order was created - time in RFC3339 with millisecond precision
   *
   * @generated from field: optional aurora.core.consts.query.DateFilter created_at = 20;
   */
  createdAt?: DateFilter;

  /**
   * Creator of the order
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter created_by = 44;
   */
  createdBy?: StringFilter;

  /**
   * Timestamp when order was last changed - time in RFC3339 with millisecond precision
   *
   * @generated from field: optional aurora.core.consts.query.DateFilter updated_at = 21;
   */
  updatedAt?: DateFilter;

  /**
   * User who last changed the order
   *
   * @generated from field: optional aurora.core.consts.query.StringFilter last_updated_by = 45;
   */
  lastUpdatedBy?: StringFilter;

  /**
   * Last prior day market price of the instrument
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter unit_price = 22;
   */
  unitPrice?: DecimalFilter;

  /**
   * Percentage in which the current price changes from the last close price for the instrument
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter price_change = 46;
   */
  priceChange?: DecimalFilter;

  /**
   * Open Market Value based on the last close price
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter open_market_value = 23;
   */
  openMarketValue?: DecimalFilter;

  /**
   * Percentage of par value (last_close_price * 100), only for fixed income
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter percentage_par = 49;
   */
  percentagePar?: DecimalFilter;

  /**
   * Time In Force strategy
   *
   * @generated from field: optional aurora.core.consts.query.TimeInForceFilter time_in_force = 24;
   */
  timeInForce?: TimeInForceFilter;

  /**
   * Timestamp for 'GTT'
   *
   * @generated from field: optional aurora.core.consts.query.DateFilter good_till_time = 25;
   */
  goodTillTime?: DateFilter;

  /**
   * Best Offer Quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter bo_quantity = 26;
   */
  boQuantity?: BigintFilter;

  /**
   * Best Offer Fee
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bo_fee = 30;
   */
  boFee?: DecimalFilter;

  /**
   * Best Offer Rebate
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bo_rebate = 31;
   */
  boRebate?: DecimalFilter;

  /**
   * Best Bid Quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter bb_quantity = 32;
   */
  bbQuantity?: BigintFilter;

  /**
   * Best Bid Fee
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bb_fee = 33;
   */
  bbFee?: DecimalFilter;

  /**
   * Best Bid Rebate
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bb_rebate = 34;
   */
  bbRebate?: DecimalFilter;

  /**
   * BBO Quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter bbo_quantity = 35;
   */
  bboQuantity?: BigintFilter;

  /**
   * BBO Fee
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bbo_fee = 36;
   */
  bboFee?: DecimalFilter;

  /**
   * BBO Rebate
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bbo_rebate = 37;
   */
  bboRebate?: DecimalFilter;

  /**
   * Spread% (Rebate)
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bbo_spread_pct_rebate = 39;
   */
  bboSpreadPctRebate?: DecimalFilter;

  /**
   * Spread vs BBO (Fee)
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bbo_spread_vs_fee = 40;
   */
  bboSpreadVsFee?: DecimalFilter;

  /**
   * Spread vs BBO (Rebate)
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter bbo_spread_vs_rebate = 41;
   */
  bboSpreadVsRebate?: DecimalFilter;

  /**
   * BBO Agreement
   *
   * @generated from field: optional aurora.core.consts.query.StringSetFilter bbo_agreement_ids = 42;
   */
  bboAgreementIds?: StringSetFilter;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.QueryOrdersFilter.
 * Use `create(QueryOrdersFilterSchema)` to create a new message.
 */
export const QueryOrdersFilterSchema: GenMessage<QueryOrdersFilter> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 16);

/**
 * @generated from message aurora.core.apiengine.omsv1.QueryOrdersSort
 */
export type QueryOrdersSort = Message<"aurora.core.apiengine.omsv1.QueryOrdersSort"> & {
  /**
   * Fields to sort on
   *
   * @generated from field: aurora.core.consts.query.SortableField field = 1;
   */
  field: SortableField;

  /**
   * Sorting order
   *
   * @generated from field: aurora.core.consts.query.SortOrder order = 2;
   */
  order: SortOrder;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.QueryOrdersSort.
 * Use `create(QueryOrdersSortSchema)` to create a new message.
 */
export const QueryOrdersSortSchema: GenMessage<QueryOrdersSort> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 17);

/**
 * @generated from message aurora.core.apiengine.omsv1.QueryOrdersResponse
 */
export type QueryOrdersResponse = Message<"aurora.core.apiengine.omsv1.QueryOrdersResponse"> & {
  /**
   * Unique request identifier assigned by Aurora user
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * agreements and instruments referred to in the Order
   *
   * @generated from field: map<string, aurora.core.common.protos.PbInstrumentInfo> instruments = 3;
   */
  instruments: { [key: string]: PbInstrumentInfo };

  /**
   * @generated from field: map<string, aurora.core.common.protos.PbAgreementInfo> agreements = 6;
   */
  agreements: { [key: string]: PbAgreementInfo };

  /**
   * List of OMS orders
   *
   * @generated from field: repeated aurora.core.apiengine.omsv1.FrontendOrder orders = 4;
   */
  orders: FrontendOrder[];

  /**
   * Total number of orders
   *
   * @generated from field: int32 total_count = 5;
   */
  totalCount: number;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.QueryOrdersResponse.
 * Use `create(QueryOrdersResponseSchema)` to create a new message.
 */
export const QueryOrdersResponseSchema: GenMessage<QueryOrdersResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 18);

/**
 * @generated from message aurora.core.apiengine.omsv1.FrontendOrder
 */
export type FrontendOrder = Message<"aurora.core.apiengine.omsv1.FrontendOrder"> & {
  /**
   * Provable Markets assigned order identifier for the order event notification
   *
   * @generated from field: string order_ref = 1;
   */
  orderRef: string;

  /**
   * Last known Unique order identifier used to create or modify the order assigned by Aurora user
   *
   * @generated from field: string client_order_ref = 2;
   */
  clientOrderRef: string;

  /**
   * CUSIP
   *
   * @generated from field: string cusip = 3;
   */
  cusip: string;

  /**
   * Side of order (lender or borrower)
   *
   * @generated from field: aurora.core.consts.common.Side side = 4;
   */
  side: Side;

  /**
   * The current status of the order.
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderStatus order_status = 5;
   */
  orderStatus: OmsOrderStatus;

  /**
   * The order type
   *
   * @generated from field: aurora.core.consts.oms.OmsOrderType order_type = 6;
   */
  orderType: OmsOrderType;

  /**
   * The order intent (FIRM, IOI)
   *
   * @generated from field: aurora.core.consts.oms.OrderIntent order_intent = 7;
   */
  orderIntent: OrderIntent;

  /**
   * Time In Force type (e.g. day, gtc, fok, ioc, custom)
   *
   * @generated from field: aurora.core.consts.oms.OmsTimeInForceType time_in_force_type = 8;
   */
  timeInForceType: OmsTimeInForceType;

  /**
   * Custom expiry time (only required / used when time time_in_force_type=CUSTOM_EXPIRY
   * Should be in the future
   * Will be clipped to the end of day if it's set to later than end of day
   * Time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string good_till_time = 9;
   */
  goodTillTime?: string;

  /**
   * The number of shares on the original order
   *
   * @generated from field: int64 quantity = 10;
   */
  quantity: bigint;

  /**
   * Minimum quantity of shares per execution
   *
   * @generated from field: int64 min_quantity = 11;
   */
  minQuantity: bigint;

  /**
   * Anonymous order
   *
   * @generated from field: bool anonymous = 12;
   */
  anonymous: boolean;

  /**
   * Rate limit, expressed as fee
   * Optional for certain order types: IOI
   * And not applicable for certain order types: Market
   *
   * @generated from field: optional string fee = 13;
   */
  fee?: string;

  /**
   * Rate limit, expressed as rebate (same as fee, but relative to benchmark)
   * Optional for certain order types: IOI
   * And not applicable for certain order types: Market
   *
   * @generated from field: optional string rebate = 14;
   */
  rebate?: string;

  /**
   * Agreement ids
   *
   * @generated from field: repeated string agreement_ids = 15;
   */
  agreementIds: string[];

  /**
   * Total quantity still available for matching
   *
   * @generated from field: int64 open_quantity = 16;
   */
  openQuantity: bigint;

  /**
   * Total executed quantity so far
   *
   * @generated from field: int64 total_exec_qty = 17;
   */
  totalExecQty: bigint;

  /**
   * Average rate (expressed as fee) of executed quantity so far
   * Optional, only specified if there have been executions
   *
   * @generated from field: optional string avg_exec_fee = 18;
   */
  avgExecFee?: string;

  /**
   * Average rate (expressed as rebate) of executed quantity so far
   * Optional, only specified if there have been executions
   *
   * @generated from field: optional string avg_exec_rebate = 19;
   */
  avgExecRebate?: string;

  /**
   * Order created at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 20;
   */
  createdAt: string;

  /**
   * Order was last changed at - time in RFC3339 with millisecond precision
   *
   * @generated from field: string updated_at = 21;
   */
  updatedAt: string;

  /**
   * Owner of the order
   *
   * @generated from field: string company_id = 22;
   */
  companyId: string;

  /**
   * Created by user
   *
   * @generated from field: string created_by = 23;
   */
  createdBy: string;

  /**
   * Last updated by user
   *
   * @generated from field: string last_updated_by = 24;
   */
  lastUpdatedBy: string;

  /**
   * @generated from field: optional aurora.core.apiengine.omsv1.TopOfBookFields top_of_book = 25;
   */
  topOfBook?: TopOfBookFields;

  /**
   * The number of shares exposed as Firm order
   *
   * @generated from field: int64 firm_quantity = 26;
   */
  firmQuantity: bigint;

  /**
   * The number of shares exposed as IOI order
   *
   * @generated from field: int64 ioi_quantity = 27;
   */
  ioiQuantity: bigint;

  /**
   * Allow odd lots
   *
   * @generated from field: bool allow_odd_lots = 28;
   */
  allowOddLots: boolean;

  /**
   * Percentage of par value (last_close_price * 100), only set for fixed income securities
   *
   * @generated from field: optional string percentage_par = 29;
   */
  percentagePar?: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.FrontendOrder.
 * Use `create(FrontendOrderSchema)` to create a new message.
 */
export const FrontendOrderSchema: GenMessage<FrontendOrder> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 19);

/**
 * @generated from message aurora.core.apiengine.omsv1.TopOfBookFields
 */
export type TopOfBookFields = Message<"aurora.core.apiengine.omsv1.TopOfBookFields"> & {
  /**
   * @generated from field: optional int64 bo_quantity = 1;
   */
  boQuantity?: bigint;

  /**
   * @generated from field: optional string bo_fee = 2;
   */
  boFee?: string;

  /**
   * @generated from field: optional string bo_rebate = 3;
   */
  boRebate?: string;

  /**
   * @generated from field: optional int64 bb_quantity = 4;
   */
  bbQuantity?: bigint;

  /**
   * @generated from field: optional string bb_fee = 5;
   */
  bbFee?: string;

  /**
   * @generated from field: optional string bb_rebate = 6;
   */
  bbRebate?: string;

  /**
   * @generated from field: optional int64 bbo_quantity = 7;
   */
  bboQuantity?: bigint;

  /**
   * @generated from field: optional string bbo_fee = 8;
   */
  bboFee?: string;

  /**
   * @generated from field: optional string bbo_rebate = 9;
   */
  bboRebate?: string;

  /**
   * @generated from field: optional string bbo_spread_pct_rebate = 11;
   */
  bboSpreadPctRebate?: string;

  /**
   * @generated from field: optional string bbo_spread_vs_fee = 12;
   */
  bboSpreadVsFee?: string;

  /**
   * @generated from field: optional string bbo_spread_vs_rebate = 13;
   */
  bboSpreadVsRebate?: string;

  /**
   * @generated from field: repeated string bbo_agreement_ids = 14;
   */
  bboAgreementIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.TopOfBookFields.
 * Use `create(TopOfBookFieldsSchema)` to create a new message.
 */
export const TopOfBookFieldsSchema: GenMessage<TopOfBookFields> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 20);

/**
 * @generated from message aurora.core.apiengine.omsv1.OrderCreatedEvent
 */
export type OrderCreatedEvent = Message<"aurora.core.apiengine.omsv1.OrderCreatedEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Details of the order
   *
   * @generated from field: aurora.core.apiengine.omsv1.Order order = 2;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.OrderCreatedEvent.
 * Use `create(OrderCreatedEventSchema)` to create a new message.
 */
export const OrderCreatedEventSchema: GenMessage<OrderCreatedEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 21);

/**
 * @generated from message aurora.core.apiengine.omsv1.OrderModifiedEvent
 */
export type OrderModifiedEvent = Message<"aurora.core.apiengine.omsv1.OrderModifiedEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Details of the order
   *
   * @generated from field: aurora.core.apiengine.omsv1.Order order = 2;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.OrderModifiedEvent.
 * Use `create(OrderModifiedEventSchema)` to create a new message.
 */
export const OrderModifiedEventSchema: GenMessage<OrderModifiedEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 22);

/**
 * @generated from message aurora.core.apiengine.omsv1.OrderExecutedEvent
 */
export type OrderExecutedEvent = Message<"aurora.core.apiengine.omsv1.OrderExecutedEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * Execution details
   *
   * @generated from field: aurora.core.apiengine.executionsv1.Execution execution = 3;
   */
  execution?: Execution;

  /**
   * Details about the order
   *
   * @generated from field: aurora.core.apiengine.omsv1.Order order = 4;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.OrderExecutedEvent.
 * Use `create(OrderExecutedEventSchema)` to create a new message.
 */
export const OrderExecutedEventSchema: GenMessage<OrderExecutedEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 23);

/**
 * @generated from message aurora.core.apiengine.omsv1.OrderCanceledEvent
 */
export type OrderCanceledEvent = Message<"aurora.core.apiengine.omsv1.OrderCanceledEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Details of the order
   *
   * @generated from field: aurora.core.apiengine.omsv1.Order order = 2;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.OrderCanceledEvent.
 * Use `create(OrderCanceledEventSchema)` to create a new message.
 */
export const OrderCanceledEventSchema: GenMessage<OrderCanceledEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 24);

/**
 * @generated from message aurora.core.apiengine.omsv1.OrderExpiredEvent
 */
export type OrderExpiredEvent = Message<"aurora.core.apiengine.omsv1.OrderExpiredEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Details of the order
   *
   * @generated from field: aurora.core.apiengine.omsv1.Order order = 2;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.OrderExpiredEvent.
 * Use `create(OrderExpiredEventSchema)` to create a new message.
 */
export const OrderExpiredEventSchema: GenMessage<OrderExpiredEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 25);

/**
 * @generated from message aurora.core.apiengine.omsv1.OrderClosedEvent
 */
export type OrderClosedEvent = Message<"aurora.core.apiengine.omsv1.OrderClosedEvent"> & {
  /**
   * Unique request identifier assigned to the event
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Details of the order
   *
   * @generated from field: aurora.core.apiengine.omsv1.Order order = 2;
   */
  order?: Order;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.OrderClosedEvent.
 * Use `create(OrderClosedEventSchema)` to create a new message.
 */
export const OrderClosedEventSchema: GenMessage<OrderClosedEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 26);

/**
 * @generated from message aurora.core.apiengine.omsv1.SplitOrderRequest
 */
export type SplitOrderRequest = Message<"aurora.core.apiengine.omsv1.SplitOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 quantity = 2;
   */
  quantity: bigint;

  /**
   * @generated from field: aurora.core.common.protos.RateLimit rate_limit = 3;
   */
  rateLimit?: RateLimit;

  /**
   * @generated from field: repeated string agreement_ids = 4;
   */
  agreementIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.SplitOrderRequest.
 * Use `create(SplitOrderRequestSchema)` to create a new message.
 */
export const SplitOrderRequestSchema: GenMessage<SplitOrderRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 27);

/**
 * @generated from message aurora.core.apiengine.omsv1.SplitOrderResponse
 */
export type SplitOrderResponse = Message<"aurora.core.apiengine.omsv1.SplitOrderResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.SplitOrderResponse.
 * Use `create(SplitOrderResponseSchema)` to create a new message.
 */
export const SplitOrderResponseSchema: GenMessage<SplitOrderResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 28);

/**
 * @generated from message aurora.core.apiengine.omsv1.BrokerCancelOrdersRequest
 */
export type BrokerCancelOrdersRequest = Message<"aurora.core.apiengine.omsv1.BrokerCancelOrdersRequest"> & {
  /**
   * List of order ids to be canceled
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * E-mail address for validation
   *
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.BrokerCancelOrdersRequest.
 * Use `create(BrokerCancelOrdersRequestSchema)` to create a new message.
 */
export const BrokerCancelOrdersRequestSchema: GenMessage<BrokerCancelOrdersRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 29);

/**
 * @generated from message aurora.core.apiengine.omsv1.BrokerCancelOrdersResponse
 */
export type BrokerCancelOrdersResponse = Message<"aurora.core.apiengine.omsv1.BrokerCancelOrdersResponse"> & {
  /**
   * list of order ids for which the cancellation request has been successfully received.
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * list of errors occurred while attempting to cancel the order.
   *
   * @generated from field: repeated aurora.core.apiengine.omsv1.CancelOrderError errors = 2;
   */
  errors: CancelOrderError[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.BrokerCancelOrdersResponse.
 * Use `create(BrokerCancelOrdersResponseSchema)` to create a new message.
 */
export const BrokerCancelOrdersResponseSchema: GenMessage<BrokerCancelOrdersResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 30);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelExecutionRecordsRequest
 */
export type CancelExecutionRecordsRequest = Message<"aurora.core.apiengine.omsv1.CancelExecutionRecordsRequest"> & {
  /**
   * @generated from field: repeated string execution_ids = 1;
   */
  executionIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelExecutionRecordsRequest.
 * Use `create(CancelExecutionRecordsRequestSchema)` to create a new message.
 */
export const CancelExecutionRecordsRequestSchema: GenMessage<CancelExecutionRecordsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 31);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelExecutionRecordsResponse
 */
export type CancelExecutionRecordsResponse = Message<"aurora.core.apiengine.omsv1.CancelExecutionRecordsResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelExecutionRecordsResponse.
 * Use `create(CancelExecutionRecordsResponseSchema)` to create a new message.
 */
export const CancelExecutionRecordsResponseSchema: GenMessage<CancelExecutionRecordsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 32);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelAllOrdersRequest
 */
export type CancelAllOrdersRequest = Message<"aurora.core.apiengine.omsv1.CancelAllOrdersRequest"> & {
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelAllOrdersRequest.
 * Use `create(CancelAllOrdersRequestSchema)` to create a new message.
 */
export const CancelAllOrdersRequestSchema: GenMessage<CancelAllOrdersRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 33);

/**
 * @generated from message aurora.core.apiengine.omsv1.CancelAllOrdersResponse
 */
export type CancelAllOrdersResponse = Message<"aurora.core.apiengine.omsv1.CancelAllOrdersResponse"> & {
  /**
   * @generated from field: int32 total_count = 1;
   */
  totalCount: number;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.CancelAllOrdersResponse.
 * Use `create(CancelAllOrdersResponseSchema)` to create a new message.
 */
export const CancelAllOrdersResponseSchema: GenMessage<CancelAllOrdersResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 34);

/**
 * @generated from message aurora.core.apiengine.omsv1.GetActiveOrderCountRequest
 */
export type GetActiveOrderCountRequest = Message<"aurora.core.apiengine.omsv1.GetActiveOrderCountRequest"> & {
};

/**
 * Describes the message aurora.core.apiengine.omsv1.GetActiveOrderCountRequest.
 * Use `create(GetActiveOrderCountRequestSchema)` to create a new message.
 */
export const GetActiveOrderCountRequestSchema: GenMessage<GetActiveOrderCountRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 35);

/**
 * @generated from message aurora.core.apiengine.omsv1.GetActiveOrderCountResponse
 */
export type GetActiveOrderCountResponse = Message<"aurora.core.apiengine.omsv1.GetActiveOrderCountResponse"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message aurora.core.apiengine.omsv1.GetActiveOrderCountResponse.
 * Use `create(GetActiveOrderCountResponseSchema)` to create a new message.
 */
export const GetActiveOrderCountResponseSchema: GenMessage<GetActiveOrderCountResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_oms_oms, 36);

/**
 * @generated from service aurora.core.apiengine.omsv1.OmsService
 */
export const OmsService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.CreateOrder
   */
  createOrder: {
    methodKind: "unary";
    input: typeof CreateOrderRequestSchema;
    output: typeof CreateOrderResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.ModifyOrder
   */
  modifyOrder: {
    methodKind: "unary";
    input: typeof ModifyOrderRequestSchema;
    output: typeof ModifyOrderResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.CancelOrder
   */
  cancelOrder: {
    methodKind: "unary";
    input: typeof CancelOrderRequestSchema;
    output: typeof CancelOrderResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.CancelOrders
   */
  cancelOrders: {
    methodKind: "unary";
    input: typeof CancelOrdersRequestSchema;
    output: typeof CancelOrdersResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.GetOrder
   */
  getOrder: {
    methodKind: "unary";
    input: typeof GetOrderRequestSchema;
    output: typeof GetOrderResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.ListOrders
   */
  listOrders: {
    methodKind: "unary";
    input: typeof ListOrdersRequestSchema;
    output: typeof ListOrdersResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.QueryOrders
   */
  queryOrders: {
    methodKind: "unary";
    input: typeof QueryOrdersRequestSchema;
    output: typeof QueryOrdersResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.SplitOrder
   */
  splitOrder: {
    methodKind: "unary";
    input: typeof SplitOrderRequestSchema;
    output: typeof SplitOrderResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.BrokerCancelOrders
   */
  brokerCancelOrders: {
    methodKind: "unary";
    input: typeof BrokerCancelOrdersRequestSchema;
    output: typeof BrokerCancelOrdersResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.CancelAllOrders
   */
  cancelAllOrders: {
    methodKind: "unary";
    input: typeof CancelAllOrdersRequestSchema;
    output: typeof CancelAllOrdersResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.omsv1.OmsService.GetActiveOrderCount
   */
  getActiveOrderCount: {
    methodKind: "unary";
    input: typeof GetActiveOrderCountRequestSchema;
    output: typeof GetActiveOrderCountResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_oms_oms, 0);

/**
 * @generated from service aurora.core.apiengine.omsv1.OmsEventsService
 */
export const OmsEventsService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsEventsService.OrderCreated
   */
  orderCreated: {
    methodKind: "unary";
    input: typeof OrderCreatedEventSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsEventsService.OrderModified
   */
  orderModified: {
    methodKind: "unary";
    input: typeof OrderModifiedEventSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsEventsService.OrderExecuted
   */
  orderExecuted: {
    methodKind: "unary";
    input: typeof OrderExecutedEventSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsEventsService.OrderCanceled
   */
  orderCanceled: {
    methodKind: "unary";
    input: typeof OrderCanceledEventSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsEventsService.OrderExpired
   */
  orderExpired: {
    methodKind: "unary";
    input: typeof OrderExpiredEventSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.omsv1.OmsEventsService.OrderClosed
   */
  orderClosed: {
    methodKind: "unary";
    input: typeof OrderClosedEventSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_oms_oms, 1);

